import axios from 'axios';
import config from '../config';
import {JsonHeaders} from '../constants';

export default {
    getServer(id) {
        return axios.get(config.publicPath + 'smtp_servers/' + id, {
            headers: JsonHeaders
        });
    },
    getServers(currentPage, perPage, name, user_id) {
        return axios.get(config.publicPath + 'smtp_servers', {
            params: {_page: currentPage, itemsPerPage: perPage, serverName: name, "user.id": user_id},
            headers: JsonHeaders
        });
    },
    getServerSelect(user_id = null) {
        return axios.get(config.publicPath + 'smtp_servers', {
            params: {'groups[]': 'select', "user.id": user_id, 'pagination': false},
            headers: JsonHeaders
        });
    },
    createServer(formData) {
        return axios.post(config.publicPath + 'smtp_servers', formData, {
            headers: JsonHeaders
        });
    },
    updateServer(id, formData) {
        return axios.put(config.publicPath + 'smtp_servers/' + id, formData, {
            headers: JsonHeaders
        });
    },
    deleteServer(id) {
        return axios.delete(config.publicPath + 'smtp_servers/' + id, {
            headers: JsonHeaders
        });
    }
}
